export default __webpack_public_path__ + "static/media/Rastech-update-7.9e59010c.jpg";